import { Box, IconButton, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const LocationContainer = styled(Box)({
  padding: 16,
  backgroundColor: COLORS.White,
});

export const AddressRow = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 8,
  marginBottom: 16,
});

export const AddressContent = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const AddressLabel = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  fontSize: 11,
  color: COLORS.Gray,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  marginBottom: 8,
});

export const AddressText = styled(Box)({
  fontSize: 14,
  color: COLORS.Black,
  lineHeight: 1.4,
});

export const MapsButton = styled(IconButton)({
  backgroundColor: COLORS.LightBlueBackground,
  color: COLORS.NavyBlue,
  flexShrink: 0,
  marginTop: 16,
  width: 48,
  height: 48,
  borderRadius: 12,
  '&:hover': {
    backgroundColor: COLORS.SubtleBlue,
  },
});

export const SectionDivider = styled(Box)({
  borderTop: `1px solid ${COLORS.SubtleGrey}`,
  margin: '16px 0',
});

export const ZoneBlock = styled(Box)({
  marginBottom: 16,
});

export const ZoneText = styled(Box)({
  fontSize: 14,
  color: COLORS.Black,
});

export const TradingHoursBlock = styled(Box)({
  marginBottom: 16,
});

interface TradingHoursRowProps {
  isToday?: boolean;
}

export const TradingHoursRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isToday',
})<TradingHoursRowProps>(({ isToday }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: 13,
  padding: '6px 4px',
  borderBottom: `1px solid ${COLORS.SubtleGrey}`,
  borderRadius: isToday ? 6 : 0,
  backgroundColor: isToday ? COLORS.SubtleGrey : 'transparent',
  fontWeight: isToday ? 700 : 'inherit',
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const TradingDay = styled(Box)({
  fontWeight: 'inherit',
  color: COLORS.Black,
});

interface TradingTimeProps {
  noHours?: boolean;
}

export const TradingTime = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noHours',
})<TradingTimeProps>(({ noHours }) => ({
  color: noHours ? COLORS.DarkRed : COLORS.Gray,
  fontWeight: 'inherit',
}));

export const MapEmbedContainer = styled(Box)({
  borderRadius: 8,
  overflow: 'hidden',
  border: `1px solid ${COLORS.SubtleGrey}`,
  height: 280,
  '& iframe': {
    width: '100%',
    height: '100%',
    border: 0,
  },
});

export const NoDataText = styled(Box)({
  fontSize: 13,
  color: COLORS.Gray,
  fontStyle: 'italic',
});

export const NotesBlock = styled(Box)({
  marginBottom: 16,
});

export const NotesText = styled(Box)({
  fontSize: 13,
  color: COLORS.DarkGray,
  lineHeight: 1.5,
  whiteSpace: 'pre-wrap',
});

export const ReferenceRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: 13,
  padding: '4px 0',
});

export const ReferenceLabel = styled(Box)({
  fontWeight: 500,
  color: COLORS.DarkGray,
});

export const ReferenceValue = styled(Box)({
  color: COLORS.Black,
  textAlign: 'right',
  wordBreak: 'break-word',
});

export const ContactCard = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 8,
  padding: '10px 12px',
  borderRadius: 10,
  backgroundColor: COLORS.BackgroundGrey,
  marginBottom: 8,
  '&:last-child': {
    marginBottom: 0,
  },
});

export const ContactCardContent = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const CallButton = styled(IconButton)({
  backgroundColor: COLORS.LightBlueBackground,
  color: COLORS.NavyBlue,
  flexShrink: 0,
  width: 44,
  height: 44,
  borderRadius: 12,
  alignSelf: 'center',
  '&:hover': {
    backgroundColor: COLORS.SubtleBlue,
  },
});

export const ContactName = styled(Box)({
  fontWeight: 600,
  fontSize: 13,
  color: COLORS.Black,
  marginBottom: 2,
});

export const ContactType = styled(Box)({
  fontSize: 11,
  color: COLORS.Gray,
  textTransform: 'uppercase',
  letterSpacing: 0.3,
  marginBottom: 4,
});

export const ContactDetail = styled(Box)({
  fontSize: 13,
  color: COLORS.DarkGray,
  lineHeight: 1.5,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});
